import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../media';

export const CardCommonStyles = css`
	text-decoration: none;
	color: #333;
	cursor: pointer;

	& * {
		cursor: pointer;
	}
`;

type CardWrapperProps = {
	className: string;
	isVisible: boolean;
	isPopular?: boolean;
	ref?: (node?: Element | null) => void;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
	href: string;
};

export const CardWrapper = styled.a<CardWrapperProps>`
	display: ${({ isVisible }) => (isVisible ? 'grid' : 'none')};
	grid-template-rows: 183px 1fr;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 9px 16px rgb(0 0 0 / 3%), 0 2px 10px rgb(0 0 0 / 4%),
		0 2px 10px rgb(0 0 0 / 3%), 0 1.4px 5px rgb(0 0 0 / 3%),
		0 1.17px 2px rgb(0 0 0 / 1.97%);
	transition: transform 0.5s ease-in-out;

	${media.tablet} {
		grid-template-rows: 138px 1fr;
	}
`;

export const CardWrapperMini = styled.a<CardWrapperProps>`
	display: ${({ isVisible }) => (isVisible ? 'grid' : 'none')};
	grid-template-columns: 113px auto;
	grid-template-rows: 113px;
	column-gap: 12px;

	& > img {
		border-radius: 4px;
	}
`;

export const CardContent = styled.div<{ isFromCatalogue: boolean }>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;
	height: 100%;
	padding: 13px 20px 20px;
	${media.mobile} {
		padding: ${({ isFromCatalogue }) => (isFromCatalogue ? '0' : '18px 18px 20px')};
	}
`;

export const CardImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;
